module.exports = __webpack_public_path__ + "media/homepage/coop-logo-ac8bc4e8.png";